import { Result } from 'domain/types';

import CreateLinkClient from 'use-case/link/create/createLinkClient';
import CreateLinkCriteria from 'use-case/link/create/createLinkCriteria';
import Link from 'domain/entity/link';

export type CreateLinkResult = Result<Link>;
export type CreateLink = (criteria: CreateLinkCriteria) => Promise<CreateLinkResult>;

export default (createLinkClient: CreateLinkClient): CreateLink => (criteria: CreateLinkCriteria): Promise<CreateLinkResult> =>
    createLinkClient(criteria);
